import { render, staticRenderFns } from "./addNewsletter.vue?vue&type=template&id=3479198c"
import script from "./addNewsletter.vue?vue&type=script&lang=js"
export * from "./addNewsletter.vue?vue&type=script&lang=js"
import style0 from "./addNewsletter.vue?vue&type=style&index=0&id=3479198c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports